import React from 'react';

// Small line icons that echo the SF Symbols the apps use. They are drawn here
// rather than exported from SF Symbols, because Apple's licence only covers
// those inside apps on Apple platforms, not on a website. Each takes the
// current text colour, so the amber comes from CSS. Names follow the SF Symbol
// each one stands in for.

const stroke = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
}

const SYMBOLS = {
    'lock.fill': (
        <>
            <path d="M7.5 10.5V7.4a4.5 4.5 0 0 1 9 0v3.1" {...stroke} strokeWidth={2.2} />
            <rect x="4.5" y="10" width="15" height="11.5" rx="2.6" fill="currentColor" />
        </>
    ),
    'ticket': (
        <>
            <path d="M4.5 5.5h15A2.5 2.5 0 0 1 22 8v2a2 2 0 0 0 0 4v2a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 16v-2a2 2 0 0 0 0-4V8a2.5 2.5 0 0 1 2.5-2.5z" {...stroke} />
            <path d="M15.5 8v8" {...stroke} strokeDasharray="1.4 2" />
        </>
    ),
    'person.3': (
        <>
            <circle cx="12" cy="8.2" r="3.1" {...stroke} />
            <path d="M6.9 19.5v-.6a5.1 5.1 0 0 1 10.2 0v.6" {...stroke} />
            <circle cx="5.2" cy="9.8" r="2.3" {...stroke} />
            <path d="M1.5 18.5v-.4a3.7 3.7 0 0 1 4.4-3.6" {...stroke} />
            <circle cx="18.8" cy="9.8" r="2.3" {...stroke} />
            <path d="M22.5 18.5v-.4a3.7 3.7 0 0 0-4.4-3.6" {...stroke} />
        </>
    ),
    'character.book.closed': (
        <>
            <path d="M6.6 2.8h11.1a1.8 1.8 0 0 1 1.8 1.8v14.8a1.8 1.8 0 0 1-1.8 1.8H6.6a2.1 2.1 0 0 1-2.1-2.1V4.9a2.1 2.1 0 0 1 2.1-2.1z" {...stroke} />
            <path d="M7.7 2.8v18.4" {...stroke} />
            <path d="M11.2 15.4l2.4-7.2 2.4 7.2M12.1 12.9h3" {...stroke} />
        </>
    ),
    // 文 and A, one language into another
    'translate': (
        <>
            <path d="M2.6 5.4h9.6M7.4 2.9v2.5" {...stroke} />
            <path d="M4.5 8.3c1.2 3.5 3.5 6 6.8 7.4M10.3 8.3c-1.2 3.5-3.5 6-6.8 7.4" {...stroke} />
            <path d="M12.9 21.2l4-10.4 4 10.4M14.4 17.6h5" {...stroke} />
        </>
    ),
    'captions.bubble': (
        <>
            <path d="M5 3.8h14a3 3 0 0 1 3 3v7.4a3 3 0 0 1-3 3h-8l-4.6 3.6v-3.6H5a3 3 0 0 1-3-3V6.8a3 3 0 0 1 3-3z" {...stroke} />
            <path d="M6.3 9h3.8M12.3 9h5.4M6.3 12.6h6.8M15.4 12.6h2.3" {...stroke} />
        </>
    )
}

// decorative, so screen readers skip it - the heading next to it says it all
const CVSymbol = ({ name, className = '' }) => (
    <svg className={`cv-symbol${className ? ` ${className}` : ''}`} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        {SYMBOLS[name]}
    </svg>
)

export default CVSymbol;
